import * as types from './mutation_types'

export default {
  [types.SET_APP_READY] (state) {
    state.appReady = true
  }
}
